var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"/orders/create"}},[_c('button',{staticClass:"create-order-btn"},[_c('i',{staticClass:"acclaro-icon ai-add"}),_vm._v(" "),_c('span',[_vm._v("Create New Order")])])])
}]

export { render, staticRenderFns }